module.exports = __webpack_public_path__ + "static/media/music2.f5da47ff.mp3";